import { IReservationR1InvoiceInfo } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getR1InvoiceInfo = ({
  calculationId,
}: {
  calculationId: string;
}): Promise<IReservationR1InvoiceInfo> =>
  API.get(`/api/accommodation/calculations/${calculationId}/r1-invoice-info`)?.then(
    res => res?.data,
  );
